module.exports = __webpack_public_path__ + "static/media/035.b504e8b3.jpg";